<template>
  <aside class="Panel PopinVideo">
    <transition name="fade" appear v-if="data"><div class="Panel_cache" @click="closePanel"></div></transition>
    
    <transition name="fade" appear>
      <button class="Panel_close" @click="closePanel" v-if="data"><i class="fal fa-times"></i></button>
    </transition>

    <transition name="video" appear>
      <div class="PopinVideo_wrapper" v-if="data" ref="wrapper" v-html="data">
        
      </div>
    </transition>
    
  </aside>
</template>

<script>
  import panel from '@/mixins/panel'

  export default {
    name: "PopinVideo",
    mixins: [ panel ],
    props: [ 'data' ]
  }
</script>

<style lang="stylus">
// .PanelAdvice
.PopinVideo

  .Panel

    &_close

      color white

  &_wrapper

    position absolute
    top 50%
    background-color black
    left 50%
    transform translate(-50%, -50%) scale(1)
    width 80%
    max-width 1024px
    padding-top 45%
    box-sizing border-box

    iframe 

      position absolute
      height auto
      top 0px
      left 0px
      width 100%
      height 100%

  
</style>